// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"full-height-module--wrapper--c0jKj","inverted":"full-height-module--inverted--38nJ1"};